import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import SelectionButton from './SelectionButton';
import SvgGraph from '../../asset/svg/Graph';

import {helper, http, api} from '../../common/common';

const styles = (theme) => {
    return {
        view: {
            position: 'absolute',
            backgroundColor: 'rgba(255,255,255,0.97)',
            textAlign: 'center',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        },
        container: {
            position: 'absolute',
            width: 630,
            top: 24,
            bottom: 24,
            left: 'calc(50% - 297px)',
            right: 'calc(50% - 297px - 36px)',
        },
        previewPanel: {
            position: 'absolute',
            width: '100%',
            top: 96,
            bottom: 96,
            overflow: 'auto',
        },
        headingText: {
            position: 'absolute',
            width: 594,
            left: 0,
            top: 0,
            color: theme.palette.text.primary,
        },
        subheadingText: {
            position: 'absolute',
            width: 594,
            left: 0,
            top: 40,
            color: theme.palette.text.secondary,
        },
        controlGroup: {
            position: 'absolute',
            width: 594,
            height: 36,
            left: 0,
            bottom: 24,
            textAlign: 'right',
        },
        control: {
            float: 'right',
            marginRight: 8,
            marginLeft: 8,
        },
        image: {
            width: 172,
            height: 84,
            marginTop: 4,
            marginLeft: 4,
            marginRight: 4,
        },
        iconContainer: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            width: 172,
            height: 84,
            marginTop: 4,
            marginLeft: 4,
            marginRight: 4,
        },
        icon: {
            ...theme.iconStyle.size[64],
            ...theme.iconStyle.darkInactive,
            marginTop: 10,
            marginBottom: 10,
        },
        label: {
            marginTop: 4,
            marginBottom: 4,
            marginLeft: 8,
            marginRight: 8,
            color: theme.palette.text.primary,
            fontWeight: 500,
            fontSize: 16,
        },
        costLabel: {
            marginTop: 4,
            marginBottom: 4,
            marginLeft: 8,
            marginRight: 8,
            color: theme.palette.text.secondary,
            fontWeight: 400,
            fontSize: 12,
        },
    };
}

class Selection extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCount: 0,
            pending: true,
        };

        this._cancelToken = http.CancelToken.source();
        this._analysisList = [];
        this._selectedAnalysis = {};
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return (this.props.open !== nextProps.open ||
            this.state.selectedCount !== nextState.selectedCount ||
            this.state.pending !== nextState.pending);
    }

    componentDidUpdate = (prevProps, prevState) => {
        if (prevProps.open === false && this.props.open === true) {
            this.setState({
                selectedCount: 0
            });

            this._selectedAnalysis = {};

            this._requestPriceList(this.props.regionInfo.organization);
        }
    }

    componentWillUnmount = () => {
        if (this._cancelToken) {
            this._cancelToken.cancel();
        }
    }

    render = () => {
        if (!this.props.open) {
            return null;
        }

        const {classes} = this.props;

        if (this.state.pending) {
            return null;
        }

        return (
            <div className={classes.view}>
                <div className={classes.container}>
                    <Typography
                        className={classes.headingText}
                        align='center'
                        variant='h4'
                    >
                        Analysis
                    </Typography>
                    <Typography
                        className={classes.subheadingText}
                        align='center'
                        variant='subtitle1'
                    >
                        Select at least one analysis
                    </Typography>
                    <div className={classes.previewPanel}>
                        {this._analysisList.map(this._renderAnalysisOption)}
                    </div>
                    <div className={classes.controlGroup}>
                        <Button
                            className={classes.control}
                            color='secondary'
                            autoFocus={true}
                            variant='contained'
                            disabled={this.state.selectedCount === 0}
                            onClick={this._handleContinue}
                        >
                            Next
                        </Button>
                        <Button
                            className={classes.control}
                            color='secondary'
                            onClick={this._handleCancel}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    _renderAnalysisOption = (data, index, arr) => {
        const {classes} = this.props;

        const display = (data.location) ?
            <img
                className={classes.image}
                src={api.tasking() +
                    '/price-image?access_code=' + this.props.getAccessCode() +
                    '&organization=' + this.props.regionInfo.organization +
                    '&key=' + data.key}
                alt=''
            /> :
            <div className={classes.iconContainer}>
                <SvgGraph className={classes.icon}/>
            </div>;

        return (
            <SelectionButton
                key={data.key}
                value={index}
                disabled={data.disabled}
                onClick={this._onSelect}
            >
                {display}
                <Typography
                    className={classes.label}
                    align='left'
                >
                    {data.label}
                </Typography>
                <Typography
                    className={classes.costLabel}
                    align='left'
                >
                    {data.unit_cost.toLocaleString('en')} USD/Ha
                </Typography>
            </SelectionButton>
        )
    }

    _onSelect = (e, value, selected) => {
        const entry = this._analysisList[value];
        var count = this.state.selectedCount;

        if (selected) {
            this._selectedAnalysis[entry.key] = {
                key: entry.key,
                label: entry.label,
                unit_cost: entry.unit_cost,
            };
            count += 1;
        } else {
            delete this._selectedAnalysis[entry.key];
            count -= 1;
        }

        this.setState({selectedCount: count});
    }

    _handleContinue = () => {
        if (this.props.onNext) {
            this.props.onNext(this._selectedAnalysis);
        }
    }

    _handleCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    _toAnalysisInfo = (data) => {
        data.disabled = !this._filterImagery(data.filter);
        data.unit_cost = data.unit_cost * 0.01;

        return data;
    }

    _filterImagery = (filter) => {
        for (const f of filter) {
            if (this.props.overlayInfo.mode === f || f === 'all') {
                return true;
            }
        }

        return false;
    }

    _processError = (error) => {
        if (this.props.onError) {
            this.props.onError(error);
        }
    }

    _requestPriceList = async (organization) => {
        try {
            const response = await http.get(api.tasking() + '/price', {
                params: {
                    'access_code': this.props.getAccessCode(),
                    'organization': organization,
                },
                cancelToken: this._cancelToken.token,
            });

            this._analysisList = response.data.list.map(this._toAnalysisInfo);

            this.setState({
                pending: false,
            });
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            this._handleCancel();

            const e = helper.sanitizeError(error, 'Price Error', 'Missing price list', 'warn_only');
            this._processError(e);
        }
    }
}

Selection.propTypes = {
    open: PropTypes.bool.isRequired,
    regionInfo: PropTypes.object,
    overlayInfo: PropTypes.object,
    getAccessCode: PropTypes.func.isRequired,
    onNext: PropTypes.func,
    onCancel: PropTypes.func,
    onError: PropTypes.func,
}

export default withStyles(styles)(Selection);
